import { useNavigate } from 'react-router-dom';
import { useGetUserQuery } from 'services/userApi';
import { useGetMyPendingApprovalCountQuery } from 'services/vendorPaymentsApi';

export const PendingApprovalsBanner = () => {
  const navigate = useNavigate();
  const { data: user } = useGetUserQuery({});
  const isAdmin = user?.roles?.includes('admin');
  const showPendingBadge = !!(isAdmin && user?.customer?.requires_payment_approval);
  const { data: pending } = useGetMyPendingApprovalCountQuery(undefined, {
    skip: !showPendingBadge,
    pollingInterval: 60_000,
  });
  const count = showPendingBadge ? pending?.count ?? 0 : 0;
  if (count === 0) return null;
  return (
    <button
      type="button"
      onClick={() => navigate('/approvals')}
      className="text-14s font-medium text-primary-500 hover:underline cursor-pointer"
    >
      You have {count} pending approval{count === 1 ? '' : 's'}
    </button>
  );
};
